import { socket } from './config';

const dialogApi = {
  getDialogs: () => {
    const query = JSON.stringify({
      message: `{
        dialogs {
         expert_id
         dialog_id
         status_id
         is_regular_customer
         dialog_type_id
         used_hints
         unread_count
         last_update_timestamp
         last_received_message {
           timestamp
           content
         }
         expert {
          sender_id
          name
          picture_path
         }
         expert_rating {
          rating
         }
         buyer_car_brand
       }
      }
    `,
      queryName: 'dialogs',
    });
    socket.emit('graphql', query);
  },
  findNewExpert: () => {
    // INFO: создание нового диалога с другим экспертом
    const query = JSON.stringify({
      message: `mutation {
          message: findNewExpert {
            dialogId
          }
        }`,
      queryName: 'findNewExpert',
    });
    socket.emit('graphql', query);
  }, 
  fetchDialogsCount: () => {
    const query = JSON.stringify({
      // INFO: обновление счётчика кол-ва ивентов
      message: `{
          dialogs {
            status_id,
            dialog_id,
            unread_count
          }
        }`,
      queryName: 'dialogsCount',
    });
    socket.emit('graphql', query);
  },
};

export default dialogApi;
